import { axiosPost } from "../Redux/axiosHelper";

export const addLiveUpdate = async (payload: any) => {
  const response = await axiosPost(payload, `v1/live-updates/add-update`);
};
